import {
  ResponseTdeDateAndGeneralStudentWinnersList,
  ResponseTdeInit,
  ResponseTdeMySchoolData,
  ResponseTdeRankingData,
  ResponseTdeSchoolWinnersList,
  TdeMySchoolParams,
  TdeWinnersParams,
} from '@/types/tde';
import { axiosErrorHandler, SERVER, TEXTS, URLs } from '@/utils';
import axiosGdt, { axiosGdtWithoutCredentials } from '@/utils/axiosGdt';

const baseUrl = `${SERVER}/ganadores`;

// Servicio que retorna si el usuario participa o no de un TDE.
export const tdeInit = axiosErrorHandler(async () => {
  const response = await axiosGdt.get<ResponseTdeInit>(
    URLs.TORNEO_ESCUELA.TDE_INIT
  );
  return response.data;
}, TEXTS.defaultError);

// Servicio que retorna información del ranking (Escuelas/Alumnos)
export const tdeSchoolData = axiosErrorHandler(
  async (value?: boolean) => {
    const response = await axiosGdt.get<ResponseTdeRankingData>(
      URLs.TORNEO_ESCUELA.TDE_RANKING_DATOS,
      {
        params: {
          primaria: value,
        },
      }
    );
    return response.data;
  },
  TEXTS.defaultError,
  { silentStatusCodes: [404] }
);

// Servicio que retorna datos para ranking mi escuela.
export const tdeMySchool = axiosErrorHandler(
  async ({ idEscuela, tipoRanking, primaria }: TdeMySchoolParams) => {
    const response = await axiosGdt.get<ResponseTdeMySchoolData>(
      URLs.TORNEO_ESCUELA.TDE_MI_ESCUELA,
      {
        params: {
          idEscuela,
          tipoRanking,
          primaria,
        },
      }
    );
    return response.data;
  },
  TEXTS.defaultError,
  { silentStatusCodes: [404] }
);

// ''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''

// Servicio estático que retorna listado de alumnos ganadores en la fecha y el gral.
export const tdeDateAndGeneralStudentWinners = axiosErrorHandler(
  async ({ tipo, nivel, idFecha }: TdeWinnersParams) => {
    const url = `${baseUrl}/te_alumnos_${tipo}_${nivel}_${idFecha}.json`;

    const response =
      await axiosGdtWithoutCredentials.get<ResponseTdeDateAndGeneralStudentWinnersList>(
        url
      );
    return response.data;
  },
  TEXTS.defaultError,
  { silentStatusCodes: [404] }
);

// Servicio estático que retorna listado de escuelas ganadoras en la fecha.
export const tdeDateSchoolWinnersList = axiosErrorHandler(
  async ({ nivel, idFecha }: TdeWinnersParams) => {
    const url = `${baseUrl}/te_escuelas_fecha_${nivel}_${idFecha}.json`;

    const response =
      await axiosGdtWithoutCredentials.get<ResponseTdeSchoolWinnersList>(url);
    return response.data;
  },
  TEXTS.defaultError,
  { silentStatusCodes: [404] }
);

// Servicio estático que retorna listado de escuelas ganadoras en el torneo.
export const tdeTournamentSchoolWinnerList = axiosErrorHandler(
  async ({ nivel, idFecha }: TdeWinnersParams) => {
    const url = `${baseUrl}/te_escuelas_gral_${nivel}_${idFecha}.json`;

    const response =
      await axiosGdtWithoutCredentials.get<ResponseTdeSchoolWinnersList>(url);
    return response.data;
  },
  TEXTS.defaultError,
  { silentStatusCodes: [404] }
);
